/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Audit_Filter_Clear_DateInputs */

const en_audit_filter_clear_date = /** @type {(inputs: Audit_Filter_Clear_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Clear ${i?.label}`)
};

const pt_br2_audit_filter_clear_date = /** @type {(inputs: Audit_Filter_Clear_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limpar ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Clear {label}" |
*
* @param {Audit_Filter_Clear_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_clear_date = /** @type {((inputs: Audit_Filter_Clear_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_Clear_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_clear_date(inputs)
	return pt_br2_audit_filter_clear_date(inputs)
});